import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';


const SpreadStatsViewer = (props) => {

function formatNumber(value) {
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
}

  return <div>
          <div className='flex flex-row items-center gap-x-4'>
            <div className='text-xl text-ccColorDarkTeal font-semibold'>Stats per Offer</div>
          </div>
          <div className='flex flex-col gap-y-8 items-start mt-2'>
              {props.stats?.map(s => <div className='flex flex-row gap-x-4 relative'>

                <div className='bg-slate-200 rounded p-4 w-[400px] h-[300px] flex justify-center relative'>
                    <div className='h-full' >

                        <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${props.images ? props.images[s.variant-1] : ''}`} />
                    </div>                   
                  </div>
                  <div className='flex flex-col'> 
                    <div className='bg-ccColorDarkTeal text-white font-semibold font-poppins text-sm w-fit rounded px-2 py-1 mb-6'>Offer {s.variant}</div>
                    <div className='flex flex-row gap-x-8'>
                      <div className='flex flex-col gap-y-2 p-2'>
                        <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>Opens</div>
                          <div className='text-2xl font-semibold'>{s.numOpens}</div>
                        </div>
                        <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>Clicks</div>
                          <div className='text-2xl font-semibold'>{s.numClicks}</div>
                        </div>
                        <div className='bg-ccColorOrange text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>CTO</div>
                          <div className='text-2xl font-semibold'>{(s.numClicks > 0 && s.numOpens > 0) ? formatNumber(s.numClicks / s.numOpens * 100): 0}%</div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>)

              }
          </div>
      </div>
}

export default function SnippetOfferBrokerReport(props) {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [stats, setStats] = useState(undefined)
    const [imgUrls, setImgUrls] = useState(undefined)
    const [threshold, setThreshold] = useState(0)

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetInfo(undefined)
        setImgUrls(undefined)
        getSnippetStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/offerBroker/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setStats(data)

    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)
      const settings = JSON.parse(data.snippetSettings)
      setImgUrls(settings.images.map(i => i.imgB64))

    } catch (error) {
      console.log(error);
    }
  }


    return <div>
            <CcTitle>Offer Broker Report</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Total Views', value: stats?.totalOpens},
                                    {title: 'Total Clicks', value: stats?.totalClicks},
                                    {title: 'Number of variants', value: stats?.numVariants},
                                    ]} />
            </div>
            <div className='mt-6'>
              <SpreadStatsViewer stats={stats?.variantStats}
                      //winnerVariantIndex={stats?.winnerVariantIndex}
                      images={imgUrls}
                      //optimisingStrategy={stats?.optimisingStrategy}
                      //postOptimising={{opens: stats?.winnerPostOptimisingOpens, clicks: stats?.winnerPostOptimisingClicks}}
                      //threshold={threshold}
               />

            </div>
    </div>
}